import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { TREE_ACTIONS, IActionMapping, ITreeOptions, TreeComponent, TreeNode } from '@ali-hm/angular-tree-component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { GfTitleService } from '../../../core/services/core.title.service';
import { DocmanFolderModel } from '../services/docman.model.folder';
import { DocmanFileModel } from '../services/docman.model.file';
import { UiService } from '../../../core/services/core.ui.service';
import { DocmanFileRest } from '../services/docman.service.file';
import { NotificationService } from '../../../core/services/core.notification.service';
import { DragNotificationService } from '../../../core/services/core.drag-notification.service';
import { MonitorService } from '../../../core/services/core.monitor.service';
import { UserService } from '../../../core/services/core.user.service';
import { UserRest } from '../../../core/services/core.user.rest.service';
import { UploadService } from '../../../core/services/core.upload.service';
import { DocmanFolderRest } from '../services/docman.service.folder';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { StateService } from '@uirouter/angular';
import { FileDeleteModalComponent } from '../fileDeleteModal/file.delete.modal.controller';
import { FileSettingsEditModalComponent } from '../fileSettingsEditModal/file.settings.edit.modal.controller';
import { FileOrganizerModalComponent } from '../fileOrganizerModal/file.organizer.modal.controller';
import { FileRenameModalComponent } from '../fileRenameModal/file.rename.modal.controller';
import { FolderAddModalComponent} from '../folderAddModal/folder.add.modal.controller';
import { FolderRenameModalComponent } from '../folderRenameModal/folder.rename.modal.controller';
import { FolderEditModalComponent} from '../folderEditModal/folder.edit.modal.controller';
import { FolderDeleteModalComponent} from '../folderDeleteModal/folder.delete.modal.controller';
import * as _ from 'lodash';

@Component({
  selector: 'docman-panel',
  template: require('./panel.main.html')
})
export class DocmanPanelComponent implements OnInit, OnDestroy {
  @ViewChild('tree', { static: false }) tree!: TreeComponent;
  
  @Input() data: any;
  @Input() project: any;
  @Input() projectMenu: any;
  
  @ViewChild('fileUpload', { static: false }) fileUploadElement!: ElementRef;
  
  foldersTree: any;
  folders: any;
  currentFolder: any;
  files: any[] = [];
  viewType: string;
  foldersLoading = false;
  filesLoading = false;
  filesUploading: any[] = [];
  draggingOver = false;
  formErrors: any = {};
  docs: any;
  fileRendererOn = false;
  readme: any = false;
  maxUploadSize: number;
  activeTab = 'versions';
  isDragging = false;
  subscription: Subscription = new Subscription();
  draggingOverElementId: number;
  draggingOverElement: any;
  draggingOverFolderId: number = null;
  fileMoving: any;
  newFolder: any;
  treeOptions: ITreeOptions;
  nodesTest: any;
  
  constructor(
    private titleService: GfTitleService,
    private docmanFolderModel: DocmanFolderModel,
    private docmanFileModel: DocmanFileModel,
    private uiService: UiService,
    private docmanFileRest: DocmanFileRest,
    private notificationService: NotificationService,
    private dragNotificationService: DragNotificationService,
    private monitorService: MonitorService,
    private userService: UserService,
    private userRest: UserRest,
    private uploadService: UploadService,
    private docmanFolderRest: DocmanFolderRest,
    private gfTranslateService: GfTranslateService,
    private stateService: StateService,
    private modalService: NgbModal
  ) {
    let onTreeNodeDrop: IActionMapping = {
      mouse: {
        drop: (tree, node, $event, { from, to }) => {
          if (from && from.data) {
            // Internal node move
            this.onDrop($event, node.data);
          } else {
            // External drop
            this.onDrop($event, node.data);
          }
        }
      }
    };

    this.treeOptions = {
      useVirtualScroll: false,
      nodeHeight: 23,
      allowDrag: false,
      allowDrop: true,
      actionMapping: onTreeNodeDrop,
    };
  }
  
  ngOnInit() {
    this.titleService.setTitle(this.project.name, 'Docs');
    this.foldersTree = this.data.foldersTree;
    this.folders = this.data.folders;
    this.docmanFolderModel.setFolders(this.folders);
    
    this.docs = {
      title: 'Project Documents',
      isMonitored: false,
      id: this.project.id,
    };

    this.maxUploadSize = this.uploadService.getMaxUploadSize('docman');
    this.viewType = this.stateService.params['view'] === 'icons' ? 'icons' : 'list';
    
    // Initialize the drag notification service for drag/drop events
    this.dragNotificationService.initializeDragListeners();
    
    this.notificationService.subscribe('FILE_RENDERER.ON', 'FILE_RENDERER.ON',() => {
      this.fileRendererOn = true;
    });
    
    this.notificationService.subscribe('FILE_RENDERER.OFF', 'FILE_RENDERER.OFF', () => {
      setTimeout(() => {
        this.fileRendererOn = false;
      });
    });
    
    // Listens to drag events from the DragNotificationService
    this.notificationService.subscribe('DRAGOVER_START_EVENT', 'DRAGOVER_START_EVENT', () => {
      this.draggingOver = true;
    });
    
    this.notificationService.subscribe('DRAGOVER_END_EVENT', 'DRAGOVER_END_EVENT', () => {
      this.draggingOver = false;
      this.isDragging = false;
      this.draggingOverFolderId = null;
      // Cleans up any visual indicators
      const draggingElements = document.querySelectorAll('.dragging');
      draggingElements.forEach(el => el.classList.remove('dragging'));
    });
    
    this.notificationService.subscribe('DOCMAN.FOLDER.UPDATED', 'DOCMAN.FOLDER.UPDATED', (params) => {
      this.updateFolder(params);
    });
    
    this.init();
  }
  
  ngAfterViewInit() {
    this.expandRootNode();
  }
  
  
  ngOnDestroy() {
    this.subscription.unsubscribe();
    // Clean up drag notification service
    this.dragNotificationService.destroy();

    this.notificationService.unsubscribe('FILE_RENDERER.ON');
    this.notificationService.unsubscribe('FILE_RENDERER.OFF');
    this.notificationService.unsubscribe('DRAGOVER_START_EVENT');
    this.notificationService.unsubscribe('DRAGOVER_END_EVENT');
    this.notificationService.unsubscribe('DOCMAN.FOLDER.UPDATED');
  }
  
  private init() {
    this.userRest
    .getUserPreference(this.userService.session.getUnixName(), 'docman_view_' + this.project.id, { default: 'list' })
    .then((ret: any) => {
      this.viewType = ret.preferenceValue === 'icons' ? 'icons' : 'list';
    })
    .catch(() => {
      this.viewType = 'list';
    });
    
    this.monitorService
    .get('docman', this.project.id)
    .then(() => {
      this.docs.isMonitored = 'Y';
      this.foldersTree[0].isMonitored = 'Y';
    })
    .catch(() => {
      this.docs.isMonitored = 'N';
      this.foldersTree[0].isMonitored = 'N';
    });
    
    this.setCurrentFolder(this.data.folder);
  }
  
  private refreshFolders(goRoot = false, reload: boolean = false) {
    this.foldersLoading = true;
    this.filesLoading = true;
    
    this.docmanFolderModel.getFolderTree(this.project, reload)
    .then((nodes) => {
      this.foldersTree = [nodes];
      if (goRoot) {
        this.currentFolder = this.foldersTree[0];
      }
      return this.currentFolder.id;
    })
    .then((id) => this.docmanFolderModel.getFolder(id))
    .then((folder) => this.setCurrentFolder(folder))
    .then(() => {
      this.foldersLoading = false;
      this.filesLoading = false;
      setTimeout(() => {
        this.expandRootNode();
      });
    });
  }
  
  private updateState(key: string, value: any) {
    const params = {};
    params[key] = value;
    this.stateService.go('.', params, {reload: false, notify: true});
  }
  
  private setCurrentFolder(folder: any) {
    // Ignores updates that do not provide folder data
    if (!folder) {
      return folder;
    }

    const treeFolder = this.docmanFolderModel.getFolderSubTree(folder.id, this.foldersTree);
    let targetFolder = treeFolder;

    if (!targetFolder && Array.isArray(this.foldersTree) && this.foldersTree.length > 0) {
      targetFolder = this.foldersTree[0];
    }

    if (!targetFolder && this.currentFolder) {
      targetFolder = this.currentFolder;
    }

    if (!targetFolder) {
      return folder;
    }

    if (targetFolder && Array.isArray(targetFolder.folderPath)) {
      targetFolder.folderPath.forEach((node) => {
        node.collapsed = false;
      });
    }

    this.currentFolder = targetFolder;
    this.titleService.setTitle(this.project.name, 'Docs', targetFolder.title || targetFolder.folderName);
    const folderFiles = folder && folder.rel && Array.isArray(folder.rel.currentfiles) ? folder.rel.currentfiles : [];
    this.files = folderFiles.map((file) => {
      file.isZip = this.isZip(file);
      return file;
    });

    this.setReadme();
    return folder;
  }
  
  private setReadme() {
    const file = this.files.find((file) => {
      try {
        return file.filesystem.fileName.match(/^README[\.]?(html|htm|html5|md|markdown|txt|text)?$/);
      } catch {
        return false;
      }
    });
    
    if (file) {
      this.docmanFileRest.getFileContent(file.docmanFile.id)
      .then((ret) => {
        this.readme = {
          title: file.filesystem.fileName,
          type: file.filesystem.fileName.split('.').pop(),
          content: ret.rel.content.data,
        };
      })
      .catch(() => {});
    } else {
      this.readme = false;
    }
  }
  
  private updateFilesPanel() {
    this.filesLoading = true;
    this.docmanFolderModel
    .getFolder(this.currentFolder.id)
    .then((folder) => this.setCurrentFolder(folder))
    .finally(() => {
      this.filesLoading = false;
    });
  }
  
  private isZip(file: any): boolean {
    const fileType = file.filesystem.fileType || '';
    return fileType ? /application\/zip/.test(fileType) : false;
  }
  
  private uploadFileToDocman(section: string, refId: number, file: any, hash: any, isBulkUpload: boolean) {
    const params = {
      id: hash,
      hash: hash,
      fileName: file.name,
      fileType: file.type,
      folderId: refId,
    };
    
    return this.docmanFileRest.uploadBinary(hash, params).then(
      () => {
        if (!isBulkUpload) {
          this.updateFilesPanel();
        }
        this.uiService.message.showSuccess(`File "${file.name}" uploaded successfully`, 'File Uploaded');
      },
      () => {
        if (!isBulkUpload) {
          this.uiService.message.showError(`File "${file.name}" failed to upload`);
        }
        return Promise.reject();
      }
    );
  }
  
  private addFilesToUploading(files: any[]) {
    files.forEach((file) => {
      this.filesUploading.push({
        id: file.id,
        name: file.name,
        fullPath: file.fullPath,
        size: file.size,
        bytesUploaded: 0,
        bytesRemaining: file.size,
        percentageUploaded: 0,
        percentageRemaining: 100,
      });
    });
  }
  
  private removeFileFromInProgress(section: string, refId: number, file: any) {
    if (file.failed) {
      return;
    }
    
    this.filesUploading = this.filesUploading.filter((_file) => _file.id !== file.id);
  }
  
  private progressCallback(
    section: string,
    refId: number,
    file: any,
    bytesUploaded: number,
    bytesRemaining: number,
    percentUploaded: number,
    percentRemaining: number
  ) {
    const fileInProgress = this.filesUploading.find((_file) => _file.id === file.id);
    
    if (fileInProgress) {
      fileInProgress.amountComplete = bytesUploaded;
      fileInProgress.amountTotal = bytesRemaining;
      fileInProgress.percentComplete = percentUploaded;
      fileInProgress.percentRemaining = percentRemaining;
    }
  }
  
  private fileUploadFailed(section: string, refId: number, file: any, status: string, errorMessage: string) {
    const fileInProgress = this.filesUploading.find((_file) => _file.id === file.id);
    
    if (fileInProgress) {
      fileInProgress.failed = true;
      fileInProgress.status = status;
      fileInProgress.errorMessage =
      this.gfTranslateService.translate('File upload failed') +
      ': ' +
      (errorMessage ? errorMessage : this.gfTranslateService.translate('Unknown Reason'));
    }
  }
  
  public updateFolder(params: any) {
    const folder = _.cloneDeep(params.child);
    
    if (this.foldersTree[0].id !== params.parent.id) {
      folder.parentFolderId = params.parent.id;
    } else {
      folder.parentFolderId = 0;
    }
    folder.project = folder.project.id;
    
    this.saveFolder(folder, false);
  }
  
  public buildFolderPath(folder: any): string {
    const path = folder.folderPath
    .filter((item: any) => !item.isRoot)
    .map((item: any) => item.title)
    .join('/');
    return path;
  }

  public onDragEnd(event: DragEvent) {
    // The DragNotificationService will handle the global drag end event
    // We just need to clean up local state
    this.isDragging = false;
    this.draggingOverFolderId = null;
    const target = event.target as HTMLElement;
    target.classList.remove('dragging');
    
    // Remove any lingering drag over indicators
    this.onDragLeaveCallback(this.draggingOverElement);
  }
  
  public onDragOverCallback(element: any) {
    const currentElementId = element.nativeElement.id;
    if (currentElementId == null || (currentElementId != null && this.draggingOverElementId === currentElementId)) {
      return;
    }
    
    this.onDragLeaveCallback(this.draggingOverElement);
    
    element.nativeElement.classList.add('docman-dragover');
    // Show tooltip if necessary
    
    this.draggingOverElementId = currentElementId;
    this.draggingOverElement = element;
    
    if (currentElementId === 'file-drop-area-rows') {
      setTimeout(() => {
        this.onDragLeaveCallback(element);
      }, 2000);
    }
  }
  
  public onDragLeaveCallback(element: any) {
    this.draggingOverElementId = null;
    this.draggingOverElement = null;
    
    if (!element || !element.nativeElement) {
      return;
    }
    
    // Destroy tooltip if necessary
    element.nativeElement.classList.remove('docman-dragover');
    // Remove class from children if necessary
  }
  
  public openImage(url: string) {
    if (this.isDragging) return;
    url += '/open';
    window.open(url, '_blank');
  }
  
  public moveFileToFolder(file: any, folder: any) {
    if (this.fileRendererOn) {
      return;
    }
    
    if (_.isEmpty(file) || _.isEmpty(folder)) {
      return;
    }

    // Do nothing when dropping a file onto the folder it already belongs to
    if (folder.id === this.currentFolder?.id) {
      return;
    }
    
    this.fileMoving = true;

    this.docmanFileModel
    .getFileDetails(file.id)
    .then((fileDetails) => {
      if (_.isEmpty(fileDetails)) {
        return;
      }
      
      const _file = {
        id: file.id,
        rel: {
          folders: [],
        },
      };
      
      // Add new destination folder
      _file.rel.folders.push({ id: folder.id });
      // Add remaining folders
      fileDetails.rel.folders.forEach((_folder: any) => {
        if (_folder.id !== this.currentFolder.id && _folder.id !== folder.id) {
          _file.rel.folders.push({ id: _folder.id });
        }
      });
      
      // Save file
      this.docmanFileModel
      .saveFileSettings(_file)
      .then(() => {
        this.updateFilesPanel();
        this.uiService.message.showSuccess('The file has been successfully moved');
      })
      .catch((err) => {
        this.uiService.message.showError('There was an error moving the file');
      });
    });
  }
  
  public moveFolderToFolder(folder: any, destinationFolder: any) {      
    const rootNode = Array.isArray(this.foldersTree) ? this.foldersTree[0] : null;
    const currentParentId = _.toString(_.get(folder, 'parentFolderId', folder?.folder?.parentFolderId ?? null));

    // Folders dropped onto the root must set parentFolderId to 0 so they remain top-level entries
    let resolvedParentId = currentParentId ? Number(currentParentId) : 0;

    if (rootNode && destinationFolder && destinationFolder.id === rootNode.id) {
      resolvedParentId = 0;
    } else if (rootNode && rootNode.id === folder.id) {
      resolvedParentId = 0;
    } else {
      resolvedParentId = destinationFolder ? destinationFolder.id : 0;
    }

    const stringResolvedParentId = _.toString(resolvedParentId);

    // Skip saving when nothing changed
    if (currentParentId === stringResolvedParentId) {
      this.fileMoving = false;
      return;
    }

    folder.parentFolderId = resolvedParentId;
    folder.project = _.get(folder, 'project.id', folder.project);
    
    if (folder.parentFolderId === folder.id) {
      this.fileMoving = false;
      return;
    }
    
    this.saveFolder(folder, false).finally(() => {
      this.fileMoving = false;
    });
  }

  public openFolder(folderId: number) {
    if (folderId == this.currentFolder.id) {
      return;
    }
    this.filesLoading = true;
    
    if (folderId === 0) {
      folderId = this.foldersTree[0].id;
    }
    
    const _currentFolder = this.docmanFolderModel.getFolderSubTree(folderId, this.foldersTree);
    this.updateState('path', this.buildFolderPath(_currentFolder));
  }
  
  public goHome() {
    const rootFolder = this.docmanFolderModel.getRootId();
    this.docmanFolderModel
    .getFolder(rootFolder.id)
    .then((folder) => this.setCurrentFolder(folder))
    .catch(() => {});
  }
  
  public showFileRename(file: any) {
    const modalRef = this.modalService.open(FileRenameModalComponent);
    modalRef.componentInstance.file = file.filesystem;
    modalRef.componentInstance.onRename.subscribe(() => {
      this.refreshFolders(true);
	    modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe(() => {
	    modalRef.close();
    });
  }

  public showDeleteFile(file: any) {
    const modalRef = this.modalService.open(FileDeleteModalComponent);
    modalRef.componentInstance.file = file;
    modalRef.componentInstance.onDelete.subscribe((params) => {
      this.fileDeleteCallback(params)
	    modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe(() => {
	    modalRef.close();
    });
  }
  
  public fileDeleteCallback(params) {
    _.remove(this.files, { id: params.file.id });
    this.setReadme();
  };
 
  public showEditFileSettings(file: any) {
    let fileDetails;
    let foldersFile;

    this.docmanFileModel.getFileDetails(file.docmanFile.id)
      .then(response => {
        fileDetails = response;
        foldersFile = [this.docmanFolderModel.getFolderOrganizerList(fileDetails.rel.folders, this.project)];

        const modalRef = this.modalService.open(FileSettingsEditModalComponent);
        
        modalRef.componentInstance.fileDetails = fileDetails;
        modalRef.componentInstance.foldersFile = foldersFile;
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.onEdit.subscribe((params) => {
          this.updateFilesPanel();
          this.setReadme();
          modalRef.close();
        });
        modalRef.componentInstance.onClose.subscribe((params) => {
          modalRef.close();
        });
      }, () => {
        this.uiService.message.showError('Could not retrieve file details');
      });
  }

  public showFileOrganizer(file: any) {
    const modalRef = this.modalService.open(FileOrganizerModalComponent);

    modalRef.componentInstance.file = file;
    modalRef.componentInstance.project = this.project;
    modalRef.componentInstance.onSave.subscribe((params) => {
      this.updateFilesPanel();
      modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe((params) => {
      modalRef.close();
    });
  }
 
  public showAddFolder(parentFolder: any) {
    const modalRef = this.modalService.open(FolderAddModalComponent);

    modalRef.componentInstance.parentFolder = parentFolder;
    modalRef.componentInstance.currentFolder = this.currentFolder;
    modalRef.componentInstance.rootFolder = this.docmanFolderModel.getRootId();
    modalRef.componentInstance.folders = this.data.folders;
    modalRef.componentInstance.project = this.project;
    modalRef.componentInstance.onAdd.subscribe(() => {
      this.refreshFolders();
      modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe((params) => {
      modalRef.close();
    });
  }
  
  public showRenameFolder(node: any) {
    const modalRef = this.modalService.open(FolderRenameModalComponent);

    modalRef.componentInstance.folder = node.folder;
    modalRef.componentInstance.onRename.subscribe(() => {
      this.refreshFolders(true);
      modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe((params) => {
      modalRef.close();
    });
  }

  public showEditFolder(node: any) {
    node.folder.isRoot = node.isRoot;

    const modalRef = this.modalService.open(FolderEditModalComponent);

    modalRef.componentInstance.folder = node.folder;
    modalRef.componentInstance.rootFolder = this.docmanFolderModel.getRootId();
    modalRef.componentInstance.folders = this.data.folders;
    modalRef.componentInstance.project = this.project;
    modalRef.componentInstance.onEdit.subscribe((params) => {
      this.folderEditCallback(params);
      modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe((params) => {
      modalRef.close();
    });
  }
  
  public folderEditCallback(editedFolder) {
    //Update current folder subfolders visibility state
    if (!editedFolder.isPublic) {
      _.forEach(this.folders, (folder) => {
        folder.isPublic = false;
      });
    }
    this.refreshFolders(false, true);
  }
  
  public showDeleteFolder(folder: any) {
    const modalRef = this.modalService.open(FolderDeleteModalComponent);

    modalRef.componentInstance.folder = folder;
    modalRef.componentInstance.currentFolder = this.currentFolder;
    modalRef.componentInstance.onDelete.subscribe((params) => {
      this.refreshFolders(true);
      modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe((params) => {
      modalRef.close();
    });
  }
  
  public saveNewFolder() {
    this.saveFolder(this.newFolder, true);
  }
  
  public saveFolder(folder: any, isNew: boolean) {
    folder.parentFolderId =
    isNew && this.currentFolder.isRoot && this.currentFolder.id == folder.parentFolderId ? 0 : folder.parentFolderId;
    
    this.formErrors = this.docmanFolderModel.validateFolder(folder);
    if (!_.isEmpty(this.formErrors)) {
      this.uiService.message.showError('Folder validation failed. The folder name cannot contain slashes');
      return;
    }
    
    return this.docmanFolderModel
    .saveFolder(folder, isNew)
    .then(
      (response: any) => {
        this.uiService.message.showSuccess(
          'Folder settings for ' + _.get(folder, 'folderName', '(unknown)') + ' have been updated successfully'
        );
        this.refreshFolders();
      },
      (err: any) => {
        let msg = '';
        if (err.data && err.data.folderName && err.data.folderName.length > 0) {
          if (err.data.folderName[0].type == 'required') {
            msg = 'Folder name is required';
          } else if (err.data.folderName[0].type == 'length') {
            msg = 'Folder name must have at least 5 characters';
          }
        }
        this.uiService.message.showError(
          'Error saving folder ' + _.get(folder, 'folderName', '(unknown)') + ': ' + msg
        );
      }
    )
    .finally(() => {
      // Close modals programmatically if necessary
    });
  }
  
  public setView(viewType: string) {
    this.viewType = viewType;
    this.userRest.saveUserPreference(
      this.userService.session.getUnixName(),
      'docman_view_' + this.project.id,
      this.viewType
    );
    this.updateState('view', viewType);
  }
  
  public setActiveTab(strTab: string) {
    this.uiService.setActiveTab(this, strTab);
  }

  public uploadFileToFolder(files: any[], folder: any, isBulkUpload: boolean = false) {
    this.onDragLeaveCallback(this.draggingOverElement);

    if (!Array.isArray(files)) {
      files = [files];
    }
    
    if (!isBulkUpload) {
      this.addFilesToUploading(files);
    }
    
    const options = {
      successCallback: this.uploadFileToDocman.bind(this),
      finishedCallback: this.removeFileFromInProgress.bind(this),
      progressCallback: this.progressCallback.bind(this),
      failedCallback: this.fileUploadFailed.bind(this),
      isBulkUpload: isBulkUpload,
    };
    
    return this.uploadService.uploadFiles('docmanfolder', folder.id, files, options);
  }
  
  public getFolderData(folder: any, folders: any[]): Promise<any> {
    if (folder.id > 0) {
      return Promise.resolve(folder);
    }
    
    let parentFolderId;
    if (folder.parentName == '') {
      parentFolderId = this.currentFolder.isRoot ? 0 : this.currentFolder.id;
    } else {
      const _parentFolder = _.find(folders, { path: folder.parentPath, folderName: folder.parentName });
      if (_parentFolder) {
        parentFolderId = _parentFolder.id;
      } else {
        return Promise.reject();
      }
    }
    
    folder.parentFolderId = parentFolderId;
    
    return this.docmanFolderRest.postFolder(folder).then(
      (response: any) => {
        folder.id = response.id;
        folder.isNew = true;
        return folder;
      },
      (response: any) => {
        if (_.get(response, 'data.folderName.type', '') == 'exists') {
          folder.id = _.get(response, 'data.folderName.id', 0);
          folder.isNew = false;
        }
        return folder;
      }
    );
  }

  public uploadFile(files: any) {
    let _folders: any[] = [];

    _folders = _.sortBy(
      _.filter(files, { type: 'directory' }).map((folder: any) => {
        const _folder: any = {};
        _folder.id = 0;
        _folder.folderName = folder.name;
        _folder.arrPath = folder.path.split('/');
        _folder.parentName =
          _folder.arrPath.length > 1 ? _folder.arrPath[_folder.arrPath.length - 2] : '';
        _folder.parentPath =
          _folder.arrPath.length > 1
            ? _folder.arrPath.slice(0, -1).join('/')
            : '';
        _folder.path = folder.path;
        _folder.project = this.project.id;
        _folder.files = [];
        return _folder;
      }),
      ['path']
    );
  
    _folders.unshift({
      id: this.currentFolder.id,
      folderName: '',
      path: '',
      parentPath: '',
      project: this.project.id,
    });
  
    files = _.sortBy(
      _.filter(files, (file: any) => file.type != 'directory').map((file: any) => {
        file.arrPath = _.get(file, 'path', '').split('/');
        file.arrPath = file.arrPath.slice(0, -1);
        file.path = file.arrPath.join('/');
        file.id = file.path + '/' + file.name;
        file.fullPath = file.arrPath.join(' / ') + ' / ' + file.name;
        return file;
      }),
      ['path']
    );
  
    _folders.forEach((folder: any) => {
      folder.files = _.filter(files, { path: folder.path });
    });
  
    _.remove(_folders, (folder: any) => folder.files.length == 0);
  
    this.addFilesToUploading(files);
  
    let newFolderCreated = false;
  
    // Process folders sequentially using reduce to chain promises
    _folders
      .reduce((promiseChain, folder) => {
        return promiseChain.then(() => {
          return this.getFolderData(folder, _folders).then((_folder: any) => {
            newFolderCreated = _folder.isNew ? true : newFolderCreated;
            return this.uploadFileToFolder(_folder.files, _folder, true);
          });
        });
      }, Promise.resolve())
      .then(() => {

      }, (error) => {
        console.error('Error uploading files:', error);
      })
      .then(() => {
        if (newFolderCreated) {
          this.refreshFolders();
        }
        this.updateFilesPanel();
      });
  }
  
  
  public toggleLockFile(file: any) {
    const fileEdit: any = {};
    fileEdit.id = file.id;
    fileEdit.isLocked = file.isLocked == 'Y' ? false : true;
    
    this.docmanFileModel.saveFileSettings(fileEdit).then(
      (response: any) => {
        file.isLocked = fileEdit.isLocked ? 'Y' : 'N';
        file.lockedBy = response.lockedBy;
      },
      () => {
        let msg;
        if (fileEdit.isLocked) {
          msg = 'Failed locking file';
        } else {
          msg = 'Failed unlocking file';
        }
        this.uiService.message.showError(msg);
      }
    );
  }
  
  public toggleMonitor(item: any, section: string) {
    let itemId = item.id;
    if (section == 'docmanfolder' && item.isRoot) {
      section = 'docman';
      itemId = this.project.id;
    }
    
    const title = _.get(item, 'title', _.get(item, 'description', '(unknown)'));
    
    if (item.isMonitored == 'Y') {
      this.monitorService.unset(section, itemId, false, 'You are no longer monitoring ' + title).then(
        () => {
          item.isMonitored = 'N';
          
          if (section == 'docman') {
            this.docs.isMonitored = 'N';
            const rootNode = this.foldersTree[0];
            rootNode.isMonitored = 'N';
          }
        },
        () => {
          this.uiService.message.showError('Disabling monitoring failed');
        }
      );
    } else {
      this.monitorService.set(section, itemId, 'You are now monitoring ' + title).then(
        () => {
          item.isMonitored = 'Y';
          
          if (section == 'docman') {
            this.docs.isMonitored = 'Y';
            const rootNode = this.foldersTree[0];
            rootNode.isMonitored = 'Y';
          }
        },
        () => {
          this.uiService.message.showError('Enabling monitoring failed');
        }
      );
    }
  }
  
  public unzipFile(file: any) {
    this.docmanFileModel.unzipFile(file.id, this.currentFolder.id).then(
      (ret: any) => {
        this.refreshFolders(false, true);
        this.uiService.message.showSuccess('The file "' + file.filesystem.fileName + '" was successfully unzipped');
      },
      () => {
        this.uiService.message.showError('There was a problem unzipping the file "' + file.filesystem.fileName + '"');
      }
    );
  }
  
  public fileUploadSelected() {
    this.fileUploadElement.nativeElement.click();
  }
  
  public regularFileUploadRequest(data: any) {
    this.uploadFile(data.target.files);
  }
  
  public toggleCollapse(node: any) {
    node.collapsed = !node.collapsed;
  }
  
  public getTagColor(tag: any) {
    return this.uiService.color.stringToClassColor(tag.tagName);
  }
  
  // Expand all nodes
  expandAllNodes() {
    this.tree.treeModel.expandAll();
  }
  
  // Collapse all nodes
  collapseAllNodes() {
    this.tree.treeModel.collapseAll();
  }
  
  // Toggle expansion of a single node
  toggleNode(node: any) {
    node.collapsed = !node.collapsed;
    if (node.isExpanded) {
      node.collapse();
    } else {
      node.expand();
    }
  }
  
  expandRootNode() {
    if (!this.tree || !this.tree.treeModel) {
      return;
    }
    const rootNode = this.tree.treeModel.roots[0];
    if (rootNode) {
      rootNode.expand();
    }
  }

  public onDragStart(event: DragEvent, item: any) {
    this.isDragging = true;

    if (event.dataTransfer) {
      // Store the item's ID and type (e.g., 'file' or 'folder')
      const dragData = JSON.stringify({
        type: _.has(item, 'docmanFile') ? 'file' : 'folder',
        data: _.has(item, 'docmanFile') ? item.docmanFile : item.folder
      });

      event.dataTransfer.setData('application/json', dragData);
      event.dataTransfer.effectAllowed = 'move';
  
      // Add visual feedback
      const target = event.target as HTMLElement;
      target.classList.add('dragging');
    }
  }

  public onTreeNodeDragStart(event: DragEvent, item: any) {
    this.isDragging = true;
  
    if (event.dataTransfer) {
      // Store the item's data and type (e.g., 'file' or 'folder')
      const dragData = JSON.stringify({
        type: 'folder',
        data: item?.data?.folder ?? null
      });

      event.dataTransfer.setData('application/json', dragData);
      event.dataTransfer.effectAllowed = 'move';
  
      const target = event.target as HTMLElement;
      target.classList.add('dragging');
    }
  }

  public onFolderDragOver(event: DragEvent, folderId: number) {
    event.preventDefault();
    event.stopPropagation();
    
    // Only update if hovering over a different folder
    if (this.draggingOverFolderId !== folderId) {
      this.draggingOverFolderId = folderId;
    }
  }

  public onFolderDragLeave(event: DragEvent, folderId: number) {
    event.preventDefault();
    event.stopPropagation();
    
    // Clears the highlighting for this folder
    // The timeout is meant to prevent flickering when moving between elements
    setTimeout(() => {
      if (this.draggingOverFolderId === folderId) {
        this.draggingOverFolderId = null;
      }
    }, 50);
  }

  public async onDrop(event: DragEvent, targetFolder: any) {
    event.preventDefault();
    
    // Clear the dragging over folder state
    this.draggingOverFolderId = null;
  
    if (event.dataTransfer) {
        const dataString = event.dataTransfer.getData('application/json');

        if (dataString) {
            // Internal drop handling
            try {
                const data = JSON.parse(dataString);
                if (data.type === 'file') {
                    this.moveFileToFolder(data.data, targetFolder.folder);
                } else if (data.type === 'folder') {
                    this.moveFolderToFolder(data.data, targetFolder.folder);
                }
            } catch (error) {
                console.error('Error parsing drag data:', error);
            }
        } else if (event.dataTransfer.items) {
            // External drop handling
            const items = Array.from(event.dataTransfer.items);
            const entries: any[] = [];

            const processEntry = async (entry: any, parentPath = ''): Promise<void> => {
                if (!entry) return;

                if (entry.isFile) {
                    return new Promise<void>((resolve) => {
                        entry.file((file: File) => {
                            file['path'] = parentPath;
                            entries.push({
                                type: 'file',
                                item: file
                            });
                            resolve();
                        });
                    });
                } else if (entry.isDirectory) {
                    entries.push({
                        type: 'directory',
                        path: parentPath,
                        name: entry.name
                    });
                    
                    return new Promise<void>((resolve) => {
                        const reader = entry.createReader();
                        reader.readEntries(async (subEntries: any[]) => {
                            const subPromises = subEntries.map(subEntry => {
                                const newPath = parentPath ? `${parentPath}/${entry.name}` : entry.name;
                                return processEntry(subEntry, newPath);
                            });
                            await Promise.all(subPromises);
                            resolve();
                        });
                    });
                }
            };

            try {
                // Process all entries first
                const entryPromises = items
                    .map(item => item.webkitGetAsEntry?.())
                    .filter(entry => entry != null)
                    .map(entry => processEntry(entry));

                // Wait for all entries to be collected
                await Promise.all(entryPromises);

                // Process entries only after everything is collected
                await this.processDroppedItems(entries, targetFolder);
            } catch (error) {
                console.error('Error processing dropped items:', error);
            }
        } else if (event.dataTransfer.files.length > 0) {
            // Fallback for simple file upload
            const files = Array.from(event.dataTransfer.files).map(file => ({
                type: 'file',
                item: file
            }));
            await this.processDroppedItems(files, targetFolder);
        }
    }
}

  private async processDroppedItems(entries: any[], targetFolder: any) {
    const folderMap = new Map<string, any>();
    folderMap.set('', targetFolder); // Root folder
    const rootId = this.docmanFolderModel.getRootId();
    const processedFolders = new Set(); // Track processed folder paths

    // Process folders first to create hierarchy
    for (const entry of entries) {
      if (entry.type === 'directory') {
        const pathParts = entry.path ? entry.path.split('/') : [];
        const parentPath = pathParts.join('/');
        const fullPath = entry.path ? `${entry.path}/${entry.name}` : entry.name;
        
        // Skip if we already processed this folder
        if (processedFolders.has(fullPath)) {
          continue;
        }
        processedFolders.add(fullPath);

        const parentFolder = folderMap.get(parentPath) || targetFolder;
        const newFolder = {
          id: 0,
          folderName: entry.name,
          isPublic: parentFolder.isPublic || false,
          parentFolderId: parentFolder.id === rootId.id ? 0 : parentFolder.id,
          project: this.project.id
        };

        try {
          const savedFolder = await this.docmanFolderModel.saveFolder(newFolder, true);
          folderMap.set(fullPath, savedFolder);
        } catch (error) {
          console.error('Error creating folder:', error);
        }
      }
    }

    // Now process files
    const files = entries.filter(e => e.type === 'file');
    if (files.length > 0) {
      const fileGroups = new Map<string, File[]>();
      
      // Group files by parent folder and prepare them
      files.forEach(f => {
        const parentPath = f.item['path'] || '';
        if (!fileGroups.has(parentPath)) {
          fileGroups.set(parentPath, []);
        }
        // Add necessary properties for upload tracking
        const preparedFile = f.item;
        preparedFile.id = parentPath + '/' + preparedFile.name;
        preparedFile.fullPath = parentPath ? `${parentPath} / ${preparedFile.name}` : preparedFile.name;
        fileGroups.get(parentPath).push(preparedFile);
      });

      // Process each group of files
      for (const [parentPath, groupFiles] of fileGroups) {
        const parentFolder = folderMap.get(parentPath) || targetFolder;
        // Add files to upload tracking before starting upload
        this.addFilesToUploading(groupFiles);
        await this.uploadFileToFolder(groupFiles, parentFolder, true);
      }
    }

    // Refresh view
    this.refreshFolders(false);
  }
}